var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useRef } from 'react';
import s3 from '../../helpers/awsConfig';
const ImageUpload = ({ onUpload, uploadButton, imageCount, globalFolderName, settings, setImageUploading, }) => {
    const fileInputRef = useRef(null);
    const handleFileChange = (event) => __awaiter(void 0, void 0, void 0, function* () {
        setImageUploading(true);
        const file = event.target.files[0];
        const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'];
        event.target.value = ''; // Reset the input after file selection
        if (!file)
            return;
        if (imageCount === 5) {
            onUpload(null, null, null, 'maxUploads');
            return;
        }
        if (!allowedTypes.includes(file.type)) {
            onUpload(null, null, null, 'fileType');
            return;
        }
        if (file.size / (1024 * 1024) > Number(settings.max_file_size)) {
            // File size too big in MG
            onUpload(null, null, null, 'fileSize');
            return;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
            var image = new Image();
            image.src = e.target.result;
            image.onload = () => {
                let imageHeight = image.height;
                let imageWidth = image.width;
                if (file.type != 'image/svg+xml') {
                    if (imageHeight > Number(settings.max_dimensions) || imageWidth > Number(settings.max_dimensions)) {
                        // File too big in PX
                        onUpload(null, null, null, 'fileLarge');
                        return;
                    }
                    if (imageHeight < Number(settings.min_dimensions) || imageWidth < Number(settings.min_dimensions)) {
                        // File too small in PX
                        onUpload(null, null, null, 'fileSmall');
                        return;
                    }
                }
                const uploadParams = {
                    Bucket: 'heapsgood-packaging',
                    Key: `${globalFolderName}/uploaded-images/${file.name}`,
                    Body: file,
                    ContentType: file.type,
                    ACL: 'public-read',
                };
                s3.upload(uploadParams)
                    .promise()
                    .then((data) => {
                    console.log('Upload Success: Customer Uploaded Image');
                    onUpload(data.Location, imageHeight, imageWidth, '');
                })
                    .catch((err) => {
                    console.error('Upload Error', err.message);
                });
            };
        };
        reader.readAsDataURL(file);
    });
    const handleButtonClick = () => {
        fileInputRef.current.click();
    };
    return (React.createElement("div", { className: "hg-modal__file-upload" },
        React.createElement("button", { onClick: handleButtonClick }, uploadButton),
        React.createElement("input", { ref: fileInputRef, type: "file", accept: "image/*", onChange: handleFileChange, style: { display: 'none' } })));
};
export default ImageUpload;
